import React from "react";
import { Switch, NavLink, withRouter, Route } from "react-router-dom";
import { Panel } from "@culturehq/components";

import { t } from "app/utils";

import WidgetList from "./widgets/WidgetList";
import WidgetDisabledList from "./widgets/WidgetDisabledList";
import WidgetEdit from "./widgets/WidgetEdit";

const WidgetLink = ({ to, phrase }) => (
  <li>
    <NavLink to={to} exact activeClassName="active">{phrase}</NavLink>
  </li>
);

const Widgets = () => (
  <Panel limitWidth>
    <ul className="nav nav-tabs">
      <WidgetLink to="/admin/widgets" phrase={t("Widgets")} />
      <WidgetLink to="/admin/widgets/disabled" phrase={t("Disabled")} />
    </ul>
    <Panel.Body>
      <Switch>
        <Route exact path="/admin/widgets" component={WidgetList} />
        <Route exact path="/admin/widgets/disabled" component={WidgetDisabledList} />
        <Route exact path="/admin/widgets/create" component={WidgetEdit} />
        <Route exact path="/admin/widgets/:id/edit" component={WidgetEdit} />
      </Switch>
    </Panel.Body>
  </Panel>
);

export default withRouter(Widgets);
